import React from 'react';
import { FEEDBACK_FLAGS } from 'domain/people/employee/Timeline/feedback/shared/input/FlagAsInappropriateRadioButtonGroup';
import type { Data } from 'framework/types';
import { Typography } from '@mui/material';

type FeedbackInappropriateReasonProps = {
  entity: Data;
};

const FeedbackInappropriateReason = ({ entity }: FeedbackInappropriateReasonProps) => {
  const flag = entity.getValueBySource('inappropriateContentType');
  // @ts-ignore
  const displayedFlag = FEEDBACK_FLAGS[flag];

  if (!displayedFlag) {
    return null;
  }

  return (
    <Typography className="inappropriate-reason" component="div" variant="body2" color="error">
      <i className="fa fa-flag" aria-hidden style={{ marginRight: 0.5 }} />
      {displayedFlag}
    </Typography>
  );
};

export default FeedbackInappropriateReason;
